export const BVHFileLoaderMetadata = {
    name: "bvh",
    extensions: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        ".bvh": { isBinary: false },
    },
};
//# sourceMappingURL=bvhFileLoader.metadata.js.map